const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/$calendarId/notable_dates/create.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/$calendarId/notable_dates/create")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    start: z.string().date().optional(),
    end: z.string().date().optional()
  })),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Create Notable Date",
      description: "Page title for the notable date create page"
    })
  }
});